import { createAction } from '@reduxjs/toolkit';

// set all store slices back to their initial state
export const resetAll = createAction('RESET_ALL');
